// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"30f51aa8","384":"b760ae20","675":"1bbdcd0c"}[chunkId] + ".chunk.js";
};